import modalStyle from 'assets/jss/material-dashboard-pro-react/modalStyle.js'
import buttonStyle from 'assets/jss/material-dashboard-pro-react/components/buttonStyle.js'
const customModalStyles = theme => ({
  ...modalStyle(theme),
  ...buttonStyle
})

export default customModalStyles
